export default {
    title: 'MoonGroup asistent',
    welcome: {
        greeting: 'Ahoj! Rád odpovím na otázky o MoonGroup — naše služby, produkty a způsob práce.',
        hint: 'Zkuste jednu z těchto otázek nebo se zeptejte na cokoliv:',
    },
    examplePrompts: [
        'Jaké služby nabízíte?',
        'Řekněte mi o vašich produktech',
        'Jak dlouho trvá typický projekt?',
        'Jak vás kontaktovat?',
    ],
    composer: {
        placeholder: 'Zeptejte se na cokoliv…',
        send: 'Odeslat',
        hint: 'Enter pro odeslání, Shift+Enter pro nový řádek',
        charCount: '{used}/{max}',
    },
    states: {
        thinking: 'Přemýšlím…',
        offline: 'Momentálně jsem offline — zkuste to za chvíli.',
        rateLimited: 'Trochu rychle — dejte mi chvilku a zkuste to znovu.',
        error: 'Něco se pokazilo. Zkusit znovu?',
        paused: 'Chat je na chvíli pozastaven — zkuste to prosím později.',
        inputRejected: 'Tuto zprávu se nepodařilo odeslat. Přeformulujte ji prosím a zkuste to znovu.',
        scrollToBottom: 'Nová zpráva',
    },
    toast: {
        replyReady: 'Asistent odpověděl',
        leadSent: 'Odesláno týmu — brzy se ozveme',
    },
    actions: {
        expand: 'Rozbalit',
        collapse: 'Sbalit',
        close: 'Zavřít',
        retry: 'Zkusit znovu',
        openChat: 'Otevřít chat',
        askAi: 'Zeptat se AI',
    },
};
